import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AdminMessages from "../components/AdminMessages";

const AdminMessagesPage = () => {
    return (

        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Admin Messages' />
                <AdminMessages />
            </MasterLayout>
        </>

    );
};

export default AdminMessagesPage;
